import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import ComplexProjectCard from "components/ComplexProjectCard";

// Material Dashboard 3 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";

// EditProduct article components
import ArticleImage from "./components/ArticleImage";
import MainInfo from "./components/MainInfo";
import LangForm from "./components/LangForm";
import crudsService from "services/cruds-service";
import { useLocation, useParams } from "react-router-dom";
import i18n from "i18n";
import prepareNewArr from "helper/prepareNewArr";
import deepDiff from "helper/deep-diff";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { da } from "date-fns/locale";
import MDAlert from "components/MDAlert";
import isFieldVisible from "helper/isFieldVisable";

function EditArticle() {
  const { t } = i18n;
  const baseUrl = process.env.REACT_APP_API_URL;
  let { pathname } = useLocation();

  const { id } = useParams();
  const [dataForMenu, setDataForMenu] = useState(null);
  const [data, setData] = useState([]);
  const [article, setArticle] = useState(null);
  const [info, setInfo] = useState(null);
  const [linfo, setLInfo] = useState(null);

  const [notification, setNotification] = useState({
    value: false,
    color: "info",
    message: "",
  });

  const [errors, setErrors] = useState({
    id: false,
    order: false,
    isVisible: false,
    title: false,
    description: false,
    translations: false,
    mobile_pic: false,
    web_pic: false,
    iconName: false,
  });

  const getData = async () => {
    const URL = `items/pagesDesign/${id}?fields=*,page.arname,page.id`;
    const response = await crudsService.getAllData(URL);
    setData(response.data);
    // if (response.data.type === "about_us") setArticle(response.data.content);
  };

  //if id change (when click edit from articles page) get the article data
  useEffect(() => {
    if (!id) return;
    getData();
  }, [id]);

  useEffect(() => {
    setInfo(null);
    if (!article) return;
    setInfo(article);
  }, [article]);

  const changeHandler = (e, lang) => {
    // console.log(e);

    if (lang) {
      setLInfo({
        translations: {
          ...linfo?.translations,
          [lang]: {
            ...linfo?.translations[lang],
            [e.target.name]: e.target.value,
            languages_code: lang,
          },
        },
      });
    } else {
      setInfo({
        ...info,
        [e.target.name]: e.target.value,
      });
    }
  };

  const autoSwitchChangeHandler = (name, v) => {
    setInfo({
      ...info,
      [name]: v,
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      // !linfo?.translations["ar-SA"]?.title &&
      //   alert(t("title_is_required")) &&
      //   setErrors({ ...errors, title: true });
      // if (!linfo?.translations["ar-SA"]?.title) return;
      // // console.log(article, { ...info, ...linfo }, data.content);
      // // const diff = deepDiff(article, { ...info, ...linfo });
      // // console.log(diff);
      // // console.log(info.web_pic);
      // console.log(info);

      if (info?.web_pic && info.web_pic instanceof File) {
        article?.web_pic && (await crudsService.removeFile(article.web_pic));
        const formData = new FormData();
        formData.append("attachment", info.web_pic);
        // const { data } = await HttpService.post(imageUpdate, formData, true);
        let data = await crudsService.uploadImage(formData);
        info.web_pic = data.id;
      } else if (data.web_pic === null) {
        delete info.web_pic;
      }

      if (info?.mobile_pic && data.mobile_pic instanceof File) {
        article?.mobile_pic &&
          (await crudsService.removeFile(article.mobile_pic));
        const formData = new FormData();
        formData.append("attachment", data.mobile_pic);
        let data = await crudsService.uploadImage(formData);
        data.mobile_pic = data.id;
      } else if (data.mobile_pic === null) {
        delete data.mobile_pic;
      }

      // if (data.type === "about_us") {
      //   data.content = { ...info, ...linfo };
      //   await crudsService.updateItem("items/pagesDesign/" + id, data);
      // } else
      if (article) {
        let x = data.content.filter(
          (d) => d.translations["ar-SA"] !== article.translations["ar-SA"],
        );
        x.push({ ...info, ...linfo });
        data.content = x;

        // alert(t("changes_saved_successfully"));
      } else {
        data.content.push({ ...info, ...linfo });
        // alert(t("changes_saved_successfully"));
      }
      delete data.page;
      await crudsService.updateItem("items/pagesDesign/" + id, data);
      setArticle(null);
      setInfo(null);
      setLInfo(null);
      getData();
      data?.type !== "about_us" && setArticle(null);
      setNotification({
        value: true,
        color: "success",
        text: "تم الحفظ بنجاح",
      });
    } catch (err) {
      console.error(err);
      alert(t("there_was_an_error"));
    }
  };

  // ComplexProjectCard dropdown menu state
  const [slackBotMenu, setSlackBotMenu] = useState(null);

  // TeamProfileCard dropdown menu handlers
  const openSlackBotMenu = (event, d) => {
    console.log("openSlackBotMenu", d);

    setSlackBotMenu(event.currentTarget);
    setDataForMenu(d);
  };

  const closeSlackBotMenu = () => setSlackBotMenu(null);

  const deleteItem = (e, i) => {
    if (!confirm(t("confirmDelete"))) {
      e.nativeEvent.stopImmediatePropagation();
    } else {
      data.content = data.content.filter((d) => d !== i);
      delete data.page;
      crudsService
        .updateItem("items/pagesDesign/" + id, data)
        .then(() => {
          getData();
          setNotification({
            value: true,
            color: "success",
            text: "تم الحذف بنجاح",
          });
        })
        .catch((err) => {
          console.error(err);
          alert(t("there_was_an_error"));
        });
    }
  };

  // Dropdown menu template for the ComplexProjectCard
  const renderMenu = (state, close) => (
    <Menu
      anchorEl={state}
      anchorOrigin={{ vertical: "top", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={Boolean(state)}
      onClose={close}
      keepMounted
    >
      <MenuItem
        onClick={() => {
          console.log(dataForMenu);

          setArticle(dataForMenu);
          close();
        }}
      >
        تعديل
      </MenuItem>
      {data?.type !== "contact_us" && (
        <MenuItem
          onClick={(e) => {
            deleteItem(e, dataForMenu);
            close();
          }}
        >
          حذف
        </MenuItem>
      )}
    </Menu>
  );

  return (
    <DashboardLayout>
      {/* <DashboardNavbar /> */}
      <MDBox my={3}>
        <MDBox mb={6}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} lg={6}>
              <MDTypography variant="h4" fontWeight="medium">
                {data?.title || ""}
              </MDTypography>
            </Grid>
            {/* {article && ( */}
            <Grid item xs={12} lg={6}>
              <MDBox display="flex" justifyContent="flex-end">
                <MDButton
                  variant="gradient"
                  color="info"
                  onClick={submitHandler}
                >
                  {t("save")}
                </MDButton>
              </MDBox>
            </Grid>
            {/* )} */}
          </Grid>
        </MDBox>
        {data?.content?.length > 0 && (
          <Grid container spacing={3}>
            {data?.content.map((d, index) => (
              <Grid item xs={12} md={6} lg={4} key={index}>
                <MDBox mb={1.5} mt={1.5}>
                  <ComplexProjectCard
                    color={
                      data?.type === "category_list" ||
                      data?.type === "identity" ||
                      data?.type === "contact_us" ||
                      data?.type === "receipt" ||
                      data?.type === "footer" ||
                      data?.type === "3ta2_steps" ||
                      data?.type === "about_us" ||
                      data?.type === "donations_type"
                        ? "info"
                        : "light"
                    }
                    isIcon={
                      data?.type === "category_list" ||
                      data?.type === "identity" ||
                      data?.type === "contact_us" ||
                      data?.type === "receipt" ||
                      data?.type === "footer" ||
                      data?.type === "3ta2_steps" ||
                      data?.type === "about_us" ||
                      data?.type === "donations_type" ||
                      data?.type === "data_with_image_content"
                    }
                    icon_name={d.iconName}
                    image={`${baseUrl}assets/${d.web_pic}`}
                    title={d.translations ? d.translations["ar-SA"]?.title : ""}
                    // title={d.translations["ar-SA"]?.title}
                    members={[]}
                    dropdown={{
                      action: (a) => openSlackBotMenu(a, d),
                      menu: renderMenu(slackBotMenu, closeSlackBotMenu, index),
                    }}
                  />
                </MDBox>
              </Grid>
            ))}
          </Grid>
        )}
        {notification.value && (
          <MDAlert color={notification.color} my="20px">
            <MDTypography variant="body2" color="white">
              {notification.text}
            </MDTypography>
          </MDAlert>
        )}
        {/* {article && ( */}
        <Grid container spacing={3}>
          <Grid item xs={12} lg={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <MainInfo
                  // translations_ar-SA_description
                  prefix="content_index_"
                  isFieldVisible={isFieldVisible}
                  type={data?.type}
                  page={data?.page}
                  article={article}
                  changeHandler={changeHandler}
                  autoSwitchChangeHandler={autoSwitchChangeHandler}
                  setInfo={setInfo}
                  info={info}
                  setErrors={setErrors}
                  errors={errors}
                  notification={notification}
                  setNotification={setNotification}
                />
              </Grid>
              {data?.type !== "category_list" &&
                data?.type !== "identity" &&
                data?.type !== "contact_us" &&
                data?.type !== "receipt" &&
                data?.type !== "footer" &&
                data?.type !== "todolist" &&
                data?.type !== "about_us" &&
                data?.type !== "3ta2_steps" &&
                data?.type !== "data_with_image_content" &&
                data?.type !== "data_with_table_content" && (
                  // ||
                  // data?.type === "data_with_image_content"
                  <Grid item xs={12} lg={12}>
                    <ArticleImage
                      articleImage={
                        article && article?.web_pic
                          ? `${baseUrl}assets/${article?.web_pic}`
                          : null
                      }
                      changeHandler={changeHandler}
                      imgInfo={{ name: "صورة الموقع", dimentions: "" }}
                      setInfo={setInfo}
                      info={info}
                      notification={notification}
                      setNotification={setNotification}
                      errors={errors}
                      setErrors={setErrors}
                      name="web_pic"
                    />
                  </Grid>
                )}
              {/* {((data?.type !== "category_list" &&
                data?.type !== "identity" &&
                data?.type !== "todolist" &&
                data?.type !== "contact_us" &&
                data?.type !== "footer" &&
                data?.type !== "about_us" &&
                data?.type !== "3ta2_steps") ||
                (data?.type !== "data_with_table_content" &&
                  data?.type === "data_with_image_content")) && (
                <Grid item xs={12} lg={12}>
                  <ArticleImage
                    articleImage={
                      article?.mobile_pic
                        ? `${baseUrl}assets/${article?.mobile_pic}`
                        : null
                    }
                    changeHandler={changeHandler}
                    imgInfo={{ name: "صورة الهاتف", dimentions: "300x300" }}
                    setInfo={setInfo}
                    info={info}
                    notification={notification}
                    setNotification={setNotification}
                    errors={errors}
                    setErrors={setErrors}
                    name="mobile_pic"
                  />
                </Grid>
              )} */}
            </Grid>
          </Grid>
          <Grid item xs={12} lg={9}>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <LangForm
                  prefix="content_index_"
                  isFieldVisible={isFieldVisible}
                  type={data?.type}
                  article={article}
                  changeHandler={changeHandler}
                  setInfo={setLInfo}
                  info={linfo}
                  notification={notification}
                  setNotification={setNotification}
                  errors={errors}
                  setErrors={setErrors}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/* )} */}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default EditArticle;
